<template lang="pug">
BriqPanel(data-test-id="segment-card")
  h2(data-test-id="segment-card-title") {{ segment.name }}
  BriqInput(
    type="number"
    min="0"
    label="Capacity"
    help="Determine the capacity per segment"
    v-model="segment.capacity"
    data-test-id="capacity"
    :disabled="disabled"
    )
</template>

<script>
import modelMixin from '@v/mixins/modelMixin.js'

export default {
  mixins: [
    modelMixin({
      type: Object,
      name: 'segment',
      required: true,
    }),
  ],
  props: {
    title: String,
    disabled: Boolean,
  },
}
</script>
